import { Link } from 'react-router-dom'
import { Bookmark, Heart, Clock, Play } from 'lucide-react'
import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function MovieCard({ movie, variant = 'poster' }) {
  const [inWatchlist, setInWatchlist] = useState(false)
  const [inFavorites, setInFavorites] = useState(false)

  if (variant === 'poster') {
    return (
      <Link to={`/movie/${movie.slug}`} className="group relative card-hover block">
        <div className="aspect-[2/3] rounded-lg overflow-hidden relative bg-dark-800">
          {movie.poster_url ? (
            <img
              src={movie.poster_url}
              alt={movie.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-500">
              <Play className="w-12 h-12 opacity-50" />
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <div className="flex items-center justify-between">
              <div className="flex gap-1">
                <button
                  className={`p-2 rounded-full transition-colors ${inWatchlist ? 'bg-primary-500 text-white' : 'bg-black/70 text-white hover:bg-primary-500'}`}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); setInWatchlist(!inWatchlist); }}
                  aria-label="Watchlist"
                >
                  <Bookmark className="w-5 h-5" strokeWidth={inWatchlist ? 3 : 2} />
                </button>
                <button
                  className={`p-2 rounded-full transition-colors ${inFavorites ? 'bg-red-500 text-white' : 'bg-black/70 text-white hover:bg-red-500'}`}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); setInFavorites(!inFavorites); }}
                  aria-label="Favorit"
                >
                  <Heart className="w-5 h-5" strokeWidth={inFavorites ? 3 : 2} />
                </button>
              </div>
            </div>
          </div>
          {movie.year && (
            <div className="absolute top-2 right-2 bg-black/80 text-white text-xs px-2 py-0.5 rounded">
              {movie.year}
            </div>
          )}
        </div>
        <div className="mt-2">
          <h3 className="font-semibold text-sm truncate group-hover:text-primary-500 transition-colors">{movie.title}</h3>
          <p className="text-gray-500 text-xs truncate">{movie.type === 'series' ? 'Series' : 'Film'}</p>
        </div>
      </Link>
    )
  }

  // List variant
  return (
    <Link to={`/movie/${movie.slug}`} className="group flex items-center gap-4 p-3 rounded-xl hover:bg-dark-800/50 transition-colors">
      <div className="relative w-20 h-30 flex-shrink-0 rounded-lg overflow-hidden bg-dark-800">
        {movie.poster_url ? (
          <img src={movie.poster_url} alt={movie.title} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><Play className="w-6 h-6 text-gray-500" /></div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-medium truncate group-hover:text-primary-500 transition-colors">{movie.title}</h3>
        <p className="text-gray-500 text-sm">{movie.year} • {movie.type === 'series' ? 'Series' : 'Film'}</p>
        {movie.genres && movie.genres.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-1">
            {movie.genres.slice(0, 3).map((g) => (
              <span key={g} className="text-xs bg-dark-700 text-gray-300 px-1.5 py-0.5 rounded">{g}</span>
            ))}
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button className={`p-2 rounded-lg transition-colors ${inWatchlist ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-primary-500'}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setInWatchlist(!inWatchlist); }}>
          <Bookmark className="w-5 h-5" strokeWidth={inWatchlist ? 3 : 2} />
        </button>
        <button className={`p-2 rounded-lg transition-colors ${inFavorites ? 'bg-red-500/20 text-red-500' : 'text-gray-400 hover:text-red-500'}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setInFavorites(!inFavorites); }}>
          <Heart className="w-5 h-5" strokeWidth={inFavorites ? 3 : 2} />
        </button>
      </div>
    </Link>
  )
}
